import React from 'react';
import PropTypes from 'prop-types';
import { confirmable, createConfirmation } from 'react-confirm';
import Popup from 'components/Popup';
import StatisticsList from 'components/StatisticsList';
import './styles.css';

const ViewStatistics = props => {
  const {
    show,
    dismiss,
    data: [left, right],
    title,
  } = props;

  const body = (
    <div className="view-statistics">
      <div className="view-statistics__body">
        <div className="view-statistics__column">
          <StatisticsList objectList={left} />
        </div>
        <div className="view-statistics__column">
          <StatisticsList objectList={right} />
        </div>
      </div>
    </div>
  );

  return (
    show && (
      <Popup
        actions={{
          dismiss,
        }}
        buttonsRender={null}
        bodyRender={body}
        title={title}
        popupStyles={{
          width: '100%',
          maxWidth: '1200px',
          padding: '30px 25px',
        }}
        popupTitleStyles={{
          padding: '0 25px',
        }}
        popupInnerStyles={{ marginTop: '65px' }}
      />
    )
  );
};

ViewStatistics.propTypes = {
  data: PropTypes.array,
  textSuccessBtn: PropTypes.string,
  textCancelBtn: PropTypes.string,
};

export default createConfirmation(confirmable(ViewStatistics));
